import { Merchant } from '@database/types';

import GatewayBase from './gateway-base';

export default class MacrosGlobalService extends GatewayBase {
  constructor(baseUrl: string) {
    super(baseUrl + `/v1/macros`);
  }

  get macros() {
    return {
      archive: this.archiveMacro,
      archiveCategory: this.archiveCategory,
      create: this.create,
      delete: this.deleteMacro,
      list: this.getMacrosByStoreId,
      order: {
        list: this.getMacrosForOrderView,
      },
      pin: this.pinMacro,
      unarchive: this.unarchiveMacro,
      unpin: this.unpinMacro,
      update: this.updateMacro,

      updateCategory: this.updateCategory,

      // eslint-disable-next-line sort-keys-fix/sort-keys-fix
      global: {
        archive: this.archiveGlobalMacro,
        archiveCategory: this.archiveGlobalCategory,
        create: this.createGlobalMacro,
        createCategory: this.createGlobalCategory,
        list: this.getGlobalMacros,
        update: this.updateGlobalMacro,
        updateCategory: this.updateGlobalCategory,
      },
    };
  }

  private getMacrosByStoreId = (storeId: string) => {
    return this.client.get<{
      macros: { default: Merchant.Macros[]; custom: Merchant.Macros[]; archived: Merchant.Macros[] };
      folderCounts: {
        default: Array<{ folder: string; count: number }>;
        custom: Array<{ folder: string; count: number }>;
        archived: Array<{ folder: string; count: number }>;
      };
    }>('/store/' + storeId);
  };

  private create = (body: {
    accountId: string;
    storeIds: string[];
    folder: string;
    title?: string;
    content?: string;
  }) => {
    return this.client.post('', body);
  };

  private updateMacro = (macroId: string, body: { title: string; content: string }) => {
    return this.client.put('/' + macroId, body);
  };

  private updateCategory = (oldFolder: string, body: { newFolder: string }) => {
    return this.client.put('/category/' + oldFolder, body);
  };

  private archiveMacro = (macroId: string, storeId?: string) => {
    const url = storeId ? `/${macroId}?storeId=${storeId}` : `/${macroId}`;

    return this.client.delete(url);
  };

  private unarchiveMacro = (macroId: string, storeId?: string) => {
    const url = '/' + macroId + '/unarchive' + (storeId ? '?storeId=' + storeId : '');

    return this.client.put(url);
  };

  private deleteMacro = (macroId: string) => {
    return this.client.delete('/' + macroId + '/delete');
  };

  private archiveCategory = (type: string, folder: string, storeId: string) => {
    return this.client.delete('/category/' + type + '/' + folder + '/' + storeId);
  };

  private getGlobalMacros = () => {
    return this.client.get<Merchant.Macros[]>('/global');
  };

  private createGlobalMacro = (body: unknown) => {
    return this.client.post('/global', body);
  };

  private createGlobalCategory = (body: unknown) => {
    return this.client.post('/global/category', body);
  };

  private updateGlobalMacro = (macroId: string, body: { title: string; content: string }) => {
    return this.client.put('/global/' + macroId, body);
  };

  private updateGlobalCategory = (oldFolder: string, body: { newFolder: string }) => {
    return this.client.put('/global/category/' + oldFolder, body);
  };

  private archiveGlobalMacro = (macroId: string) => {
    return this.client.delete('/global/' + macroId);
  };

  private archiveGlobalCategory = (folder: string) => {
    return this.client.delete('/global/category/' + folder);
  };

  private pinMacro = (macroId: string, storeId?: string) => {
    const url = storeId ? `/${macroId}/pin?storeId=${storeId}` : `/${macroId}/pin`;

    return this.client.put(url);
  };

  private unpinMacro = (macroId: string, storeId?: string) => {
    const url = storeId ? `/${macroId}/unpin?storeId=${storeId}` : `/${macroId}/unpin`;

    return this.client.put(url);
  };

  private getMacrosForOrderView = (storeId: string) => {
    return this.client.get(`/order/${storeId}`);
  };
}
